import React, { useState } from "react"
import { Eye, EyeOff } from "lucide-react"
import { Input } from "@shadcn/components/ui/input"
import { cn } from "@shadcn/lib/utils"

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	/** Whether the input has a validation error */
	error?: boolean
}

/**
 * Password input component with show/hide toggle
 * Supports react-hook-form integration via forwardRef
 */
export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
	({ error, className, ...props }, ref) => {
		const [showPassword, setShowPassword] = useState(false)

		return (
			<div className="relative">
				<Input
					ref={ref}
					type={showPassword ? "text" : "password"}
					className={cn(error ? "border-destructive focus-visible:ring-destructive" : "", "pr-10", className)}
					{...props}
				/>
				<button
					type="button"
					onClick={() => {
						setShowPassword(!showPassword)
					}}
					className="text-muted-foreground hover:text-foreground focus:outline-none absolute right-3 top-1/2 -translate-y-1/2"
					tabIndex={-1}
					aria-label={showPassword ? "Hide password" : "Show password"}>
					{showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
				</button>
			</div>
		)
	}
)
PasswordInput.displayName = "PasswordInput"
